import React from "react";
import { safeJSONParse } from "../../../utils/helper";
import styles from "../agent-response.module.scss";

type JDComposerAgentProps = {
    parsedContent: any;
};

export default function JDComposerAgent({
    parsedContent,
}: JDComposerAgentProps): JSX.Element {
    const answer = safeJSONParse(parsedContent?.answer);
    const question = parsedContent?.question;
    const jdPayload = answer;

    // Capitalize first letter of each word
    const capitalizeWords = (str: string) => {
        if (!str) return str;
        return str
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    return (
        <div style={{
            lineHeight: "1.6",
            color: "#333",
        }}>
            {/* Job Title and Type */}
            {jdPayload?.job_type && (
                <h2 style={{ marginBottom: "7px" }}>
                    Based on recent skill inference analysis, below are the core skills
                    and preferred qualifications for{" "}
                    {jdPayload.job_type ? ` ${jdPayload.job_type}` : ""}
                </h2>
            )}

            {/* Functional Skills */}
            <div>
                <h3 style={{ color: "#00d2aa" }}>Functional / Technical Skills</h3>

                {Array.isArray(jdPayload.functional_skills) && (
                    <div style={{ marginBottom: "7px", marginLeft: "20px" }}>
                        <h3>Core Technical Skills</h3>
                        <ul style={{ margin: "5px 0" }}>
                            {jdPayload.functional_skills.map(
                                (skill: string, idx: number) => (
                                    <li key={idx}>{skill}</li>
                                ),
                            )}
                        </ul>
                    </div>
                )}
                {Array.isArray(jdPayload.future_skills) && (
                    <div style={{ marginBottom: "7px", marginLeft: "20px" }}>
                        <h3>Future Ready Skills</h3>

                        {!jdPayload.future_skills.length && (
                            <div style={{ fontSize: "14px", marginLeft: "24px" }}>
                                No Future Ready Skills as of now
                            </div>
                        )}

                        <ul style={{ margin: "5px 0" }}>
                            {jdPayload.future_skills.map((skill: string, idx: number) => (
                                <li key={idx}>{skill}</li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>

            {/* Preferred Qualifications */}
            {jdPayload?.preferred_qualifications && jdPayload.preferred_qualifications.length > 0 && (
                <div style={{ marginBottom: "7px" }}>
                    <h3>Qualifications</h3>
                    <ul style={{ margin: "5px 0" }}>
                        {jdPayload.preferred_qualifications.map(
                            (item: any, idx: number) => (
                                <li key={idx}>
                                    {item.entity_type}: {item.entity_value}
                                </li>
                            ),
                        )}
                    </ul>
                </div>
            )}

            {/* Final Question */}
            <div className={styles.finalQuestion}>{question}</div>
        </div>
    );
}
